import React from 'react';
import classnames from 'classnames';

export const TableBoxVariant = {
  // The new-order alert: full width, centred, 28 px on phones and 32 px from tablets on.
  Alert: 'alert',
  // Order Information: under the order number, left-aligned, 26 px.
  Details: 'details',
};

/**
 * The table of a table order, big: large bold text in a light grey box, so it stands out by size
 * and place rather than a dark fill. Long names wrap; nothing is cut off. Renders nothing without
 * a label (an on-site order from before tables had names).
 */
export default function TableBox({ label, variant = TableBoxVariant.Details, className }) {
  if (!label) {
    return null;
  }

  return (
    <p
      data-testid="table-box"
      className={classnames(
        'mb-0 bg-gray-100 rounded-lg text-black font-bold leading-tight break-words [overflow-wrap:anywhere]',
        {
          'w-full px-md py-xs text-center text-[28px] sm:text-xl': variant === TableBoxVariant.Alert,
          'w-fit max-w-full px-sm py-2xs text-left text-[26px]': variant === TableBoxVariant.Details,
        },
        className,
      )}
    >
      {label}
    </p>
  );
}
